import Svg, {Circle, Ellipse, Path, type PathProps, Rect} from 'react-native-svg'

import {BRAND} from '#/lib/brand'
import {type BrandMarkElement} from '#/lib/brand/types'

/**
 * Renders the active brand's mark INSIDE a caller-provided `<Svg>` (the caller
 * owns the viewBox -- pass `BRAND.markViewBox`).
 *
 * Single-path brands (cooey) tint with the supplied `fill`, matching the old
 * COOEY_MARK_PATH behavior. Fixed-palette brands (eagledrive tile, yeet vinyl)
 * always render their own colors and ignore `fill`.
 */
export function BrandMarkPaths({fill}: {fill?: PathProps['fill']}) {
  if (BRAND.markPath) {
    return <Path fill={fill} d={BRAND.markPath} />
  }
  return <>{(BRAND.markElements ?? []).map(renderElement)}</>
}

/**
 * Small square brand-mark icon for inline pill/button use (the SSO pill when
 * `BRAND.sso.icon === 'brand'`). Tintable marks render white to sit on the
 * pill's colored background.
 */
export function BrandSsoIcon({size = 18}: {size?: number}) {
  return (
    <Svg viewBox={BRAND.markViewBox} width={size} height={size}>
      <BrandMarkPaths fill="#fff" />
    </Svg>
  )
}

function renderElement(el: BrandMarkElement, i: number) {
  switch (el.type) {
    case 'rect':
      return (
        <Rect
          key={i}
          x={el.x}
          y={el.y}
          width={el.width}
          height={el.height}
          rx={el.rx}
          fill={el.fill}
        />
      )
    case 'circle':
      return (
        <Circle
          key={i}
          cx={el.cx}
          cy={el.cy}
          r={el.r}
          fill={el.fill ?? 'none'}
          opacity={el.opacity}
          stroke={el.stroke}
          strokeWidth={el.strokeWidth}
        />
      )
    case 'ellipse':
      return (
        <Ellipse
          key={i}
          cx={el.cx}
          cy={el.cy}
          rx={el.rx}
          ry={el.ry}
          fill={el.fill}
        />
      )
    case 'path':
      return <Path key={i} d={el.d} fill={el.fill} />
  }
}
